import {
  Component,
  forwardRef,
} from '@angular/core';
import {
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FinancialProductWrapperComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/financial-product/financial-product-wrapper.component';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';

@Component({
  selector: 'app-financial-product-mobile',
  templateUrl: './financial-product-mobile.component.html',
  styleUrls: ['./financial-product-mobile.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FinancialProductMobileComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => FinancialProductMobileComponent),
      multi: true,
    },
  ],
})
export class FinancialProductMobileComponent extends FinancialProductWrapperComponent {
  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService,
  ) {
    super(route, menu, notification);
  }
}
